import React from "react";
import PropTypes from "prop-types";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, ResponsiveContainer, Cell } from "recharts";

const DispositionChart = ({ dispositionBreakdown }) => {
  if (!dispositionBreakdown || Object.keys(dispositionBreakdown).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Call Dispositions</h4>
        <div className="no-data-message">No disposition data available</div>
      </div>
    );
  }

  const data = Object.entries(dispositionBreakdown).map(([key, value], i) => ({
    label: key,
    value,
    fill: graphColors[i % graphColors.length]
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Call Dispositions</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            cx="50%"
            cy="50%"
            outerRadius={80}
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name) => [value, name]} />
        </PieChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        {data.map((item, i) => (
          <div key={i} className="legend-item">
            <div className="legend-color" style={{ backgroundColor: item.fill }} />
            <span>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

DispositionChart.propTypes = {
  dispositionBreakdown: PropTypes.object
};

export default DispositionChart;
